class HeaderAnimation {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const headerWrap = document.querySelector('.js-header');
    let lastScroll = window.scrollY;
    let scrollTimeout;
    
    // スクロールイベントでスクロール位置を更新
    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);
    
      if (window.scrollY > lastScroll) {
        // 下方向スクロール時のアニメーション
        gsap.to(headerWrap, {
          top: '-25rem',
          backgroundColor: 'transparent',
          paddingBottom: '4.3rem'
        });
      } else {
        if (window.scrollY != 0) {
          // 上方向スクロール時（途中でスクロールが止まっていない時）
          gsap.to(headerWrap, {
            top: '-4rem',
            backgroundColor: '#ECF5F8',
            paddingBottom: '2rem'
          });
        } else {
          // スクロールが一番上に戻った時
          gsap.to(headerWrap, {
            top: '-25rem',
            backgroundColor: 'transparent',
            paddingBottom: '4.3rem'
          });
        }
      }
    
      lastScroll = window.scrollY;
      scrollTimeout = setTimeout(() => {
        gsap.to(headerWrap, {
          top: '-4rem',
          backgroundColor: '#ECF5F8',
          paddingBottom: '2rem'
        });
      }, 800);
    });
    
  }
}